import Badge from "../components/Badge";
import BaseAlert from "../components/BaseAlert";
import BaseButton from "../components/BaseButton";
import BaseCheckbox from "../components/BaseCheckbox";
import BaseInput from "../components/BaseInput";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/BaseProgress";
import BaseRadio from "../components/BaseRadio";
import BaseSlider from "../components/BaseSlider";
import BaseSwitch from "../components/BaseSwitch";
import Card from "../components/Card";
import Icon from "../components/Icon";

export default {
  install(app) {       // Vue2: Vue → Vue3: app
    app.component(Badge.name, Badge);
    app.component(BaseAlert.name, BaseAlert);
    app.component(BaseButton.name, BaseButton);
    app.component(BaseInput.name, BaseInput);
    app.component(BaseCheckbox.name, BaseCheckbox);
    app.component(BasePagination.name, BasePagination);
    app.component(BaseProgress.name, BaseProgress);
    app.component(BaseRadio.name, BaseRadio);
    app.component(BaseSlider.name, BaseSlider);
    app.component(BaseSwitch.name, BaseSwitch);
    app.component(Card.name, Card);
    app.component(Icon.name, Icon);
  }
};
